export default class EventBus {
  // tslint:disable-next-line:variable-name
  _callbacks = {};

  public on(eventName, callback) {
    if (!this._callbacks[eventName]) {
      this._callbacks[eventName] = [];
    }

    this._callbacks[eventName].push(callback);
  };

  public off(eventName, callback) {
    const callbacks = this._callbacks[eventName];
    if (!callbacks) {
      return;
    }

    let index = -1;
    for (let i = 0; i < callbacks.length; i++) {
      if (callbacks[i] === callback) {
        index = i;
        break;
      }
    }

    if (index < 0) {
      return;
    }

    this._callbacks[eventName].splice(index, 1);
  };

  public trigger(eventName, ...args: any[]) {
    const callbacks = this._callbacks[eventName];
    if (!callbacks || !callbacks.length) {
      return;
    }

    for (let i = 0; i < callbacks.length; i++) {
      callbacks[i].apply(this, args);
    }
  };
}
